import API, { GraphQLResult, GRAPHQL_AUTH_MODE } from '@aws-amplify/api';
import awsExports from '../aws-exports-overriden';

API.configure(awsExports);

export interface GraphQLOptions {
  variables?: object;
  authMode?: GRAPHQL_AUTH_MODE;
}

async function callGraphQL<T>(query: any, options?: GraphQLOptions): Promise<GraphQLResult<T>> {
  try {
    return (await API.graphql({
      query,
      ...options,
    })) as GraphQLResult<T>;
  } catch (error) {
    console.log('ERROR', error);
    throw error;
  }
}

export default callGraphQL;
